import { CHANNEL_GET } from '@annunciate/query/dist/queries/channel';
import Config from '@annunciate/core/dist/utils/config';
import { useQuery } from './base';
export const useChannelQuery = (id = Config.APP_CHANNEL || 'DEFAULT') => {
    return useQuery(['channel'], CHANNEL_GET, { id });
};
//# sourceMappingURL=useChannelQuery.js.map